import builder from '../builder';
import CreditCardVisa from '../../streamline-icons/bold/credit-card-visa.svg';

export default builder('IconCreditCardVisaBold', CreditCardVisa);
